<template>
<v-card-text class="px-2">
    <div class="reservation-modal">
        <v-row class="px-2 mx-0">
            <v-col cols="12" md="3">
                <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item,heading,list-item" />
                <im-data-check v-else :item="item" />
                <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item,heading,list-item,heading,list-item" />
                <im-general v-else :item="item" />
            </v-col>
            <v-col cols="12" md="9">
                <v-row no-gutters>
                    <v-col cols="12" md="7">
                        <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item-three-line" />
                        <im-client v-else :item="item" />
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item-three-line" />
                        <im-data-price v-else :item="item">
                            <template v-if="item.channel == 'Booking'" v-slot:commision>
                                <div v-if="item.meta">
                                    <div class="im-label">
                                        {{ $t('reservations.modal.commision') }}
                                    </div>
                                    <div class="regular mt-1 mb-3">
                                        <im-price :price="item.meta.reservation.commissionamount._value" :currency="item.meta.reservation.currencycode._value" fontSize="20" />
                                    </div>
                                </div>
                            </template>
                        </im-data-price>
                        <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="actions" />
                        <im-actions v-else :item="item" @openModalCC="dialog_card=true" @openModalInvoice="dialog_invoice=true"></im-actions>
                    </v-col>
                </v-row>
                <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="list-item" />
                <template v-else>
                    <v-card v-if="item.meta" flat>
                        <div class="">
                            {{ $t('reservations.modal.rooms') }}
                        </div>
                        <div class="py-1" v-for="(room, index) in handleMetaReservation()" :key="index">
                            <im-room-booking class="my-1" :room="room" />
                        </div>
                    </v-card>
                    <div v-else>
                        <div class="">
                            {{ $t('reservations.modal.rooms') }}
                        </div>
                        <div class="py-1" v-for="(room, index) in unique_rooms" :key="index">
                            <im-room :room="room"></im-room>
                        </div>
                    </div>
                </template>
            </v-col>
        </v-row>

        <im-credit-card :dialog="dialog_card" :reservation_id="item.id" @close="exitDialogCard()"></im-credit-card>
        <im-invoice :dialog="dialog_invoice" :item="item" @close="dialog_invoice=false" />

    </div>
</v-card-text>
</template>

<script>
import defaults from "../../utils/PropDefaults.js";
import IMPrice from '../../small-components/IMPrice.vue';
import IMClient from '../Reservations/items/Client.vue';
import IMGeneral from '../Reservations/items/General.vue';
import IMDataCheck from '../Reservations/items/DataCheck.vue';
import IMDataPrice from '../Reservations/items/DataPrice.vue';
import IMRoom from '../Reservations/items/Room.vue';
import IMRoomBooking from '../Reservations/items/RoomBooking.vue';
import IMActions from '../Reservations/items/Actions.vue';
import IMCreditCard from '../Reservations/CreditCard.vue';
import IMInvoice from '../Reservations/InvoiceModal.vue';
// imprt cards

export default {
    components: {
        'im-price': IMPrice,
        'im-general': IMGeneral,
        'im-client': IMClient,
        'im-data-check': IMDataCheck,
        'im-data-price': IMDataPrice,
        'im-actions': IMActions,
        'im-room': IMRoom,
        'im-room-booking': IMRoomBooking,
        'im-credit-card': IMCreditCard,
        'im-invoice': IMInvoice,
    },

    props: {
        reservation_id: [Number, String],
    },

    data() {
        return {
            loading: false,
            item: this.$clone(defaults.reservation_item),
            dialog_card: false,
            dialog_invoice: false,
            disable_button: false,
            comments_reservation: [],
            show_invoice: true,
            truncate: true,
        }
    },

    watch: {
        reservation_id: {
            immediate: true,
            handler: function () {
                this.getItem()
                this.show_invoice = true;
                this.truncate = true;
                this.comments_reservation = [];
            }
        }
    },

    created() {
        this.getItem();
    },

    computed: {
        unique_rooms: {
            get: function () {
                let rooms = this.item.rooms;
                let _unArray = [];
                rooms.forEach(function (item) {
                    let isPresent = _unArray.filter(function (elem) {
                        return JSON.stringify({ ...elem
                        }) == JSON.stringify({ ...item
                        })
                    })
                    if(isPresent.length == 0) {
                        _unArray.push(item)
                    }
                })
                _unArray.forEach(function (unique) {
                    let isPresent = rooms.filter(function (elem) {
                        return JSON.stringify({ ...unique
                        }) == JSON.stringify({ ...elem
                        })
                    })
                    unique.show = false;
                    unique.count = isPresent.length;
                })
                return _unArray
            },
            // setter
            set: function (newValue) {}
        },

    },

    methods: {
        checkQTravelDetail(value) {
            let myReg = /[CDA]+([0-9]{1,6})/g;
            return myReg.test(value);
        },
        exitDialogCard() {
            this.dialog_card = false;
            this.getItem();
        },

        handleMetaReservation() {
            if(Array.isArray(this.item.meta.reservation.room)) {
                return this.item.meta.reservation.room
            } else {
                return [this.item.meta.reservation.room]
            }
        },

        getItem() {
            if(!this.reservation_id) {
                return
            }
            this.loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations/' + this.reservation_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.item = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {});
        }
    },


}
</script>

<style lang="stylus">
.reservation-modal
    .booked
        border-style: none
        text-transform: capitalize
        color: #4CAF50
        font-size: 14px
        font-weight: 700
    .no-show
        border-style: none
        text-transform: capitalize
        color: #FFC107
        font-size: 14px
        font-weight: 700
    .canceled
        border-style: none
        text-transform: capitalize
        color: #F44336
        font-size: 14px
        font-weight: 700
    .flag-test
        text-transform: capitalize
        color: red
    .price
        font-size: 16px
        color: #4a4a4a
    .skeleton
        &.v-skeleton-loader
            >*
                padding: 5px

.description
    padding-bottom: 15px
    line-height: 15px
    max-height: 45px
    overflow: hidden
    .more
        max-height: 100%
        height: 100%
</style>
